(() => {
  function fileKey(url) {
    if (!url) return '';
    try { return decodeURIComponent(new URL(url, location.origin).pathname.split('/').pop()).replace(/_\d+x\d*(?=\.[^.]+$)/, ''); }
    catch { return ''; }
  }
  function normalizeImage(image, replacement) {
    if (!replacement || image.dataset.xcAppliedImage === replacement) return;
    image.dataset.xcAppliedImage = replacement;
    image.removeAttribute('srcset');
    image.src = replacement;
    image.width = 1000; image.height = 1000;
    image.classList.add('xc-normalized-photo');
  }
  function present(root, metadata) {
    const data = metadata || root.dataset || {};
    const replacement = data.xcNormalizedImage;
    const sourceKey = fileKey(data.xcSourceUrl);
    if (replacement && sourceKey) root.querySelectorAll('img').forEach(image => {
      if (fileKey(image.getAttribute('src')) === sourceKey) normalizeImage(image, replacement);
    });
    const brand = data.xcBrand || root.dataset?.xcBrand;
    const originalVendor = root.dataset?.xcOriginalVendor;
    if (brand && originalVendor) root.querySelectorAll('.product__text').forEach(text => {
      if (text.textContent.trim().toLowerCase() === originalVendor.trim().toLowerCase()) text.textContent = brand;
    });
  }
  window.xcApplyCatalogPresentation = present;
  function init(root) {
    if (root.matches?.('product-info[data-xc-normalized-image],product-info[data-xc-brand]')) present(root);
    root.querySelectorAll?.('product-info[data-xc-normalized-image],product-info[data-xc-brand]').forEach(node => present(node));
    if (root.matches?.('img[data-xc-normalized-image]')) normalizeImage(root, root.dataset.xcNormalizedImage);
    root.querySelectorAll?.('img[data-xc-normalized-image]').forEach(image => normalizeImage(image, image.dataset.xcNormalizedImage));
  }
  init(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) init(node);
  }))).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
